import React, { useContext, useState } from 'react'
import MarginAnalysisContext from './../MarginAnalysisContext'
import { Modal, message, Input, Checkbox, Spin } from 'antd'
import { saveMarginAnalysisScnerio } from 'api/pgads'
import { SpinContext, ErrorContext } from 'context'
import moment from 'moment'
import { freeEditEngine } from '@integec/grid-tools'

const SaveScenarioDialog = ({
  targetInfo,
  onCancelScenarioDialog,
  onClose,
  visible,
  userInfo,
  lostType = '1',
  // units,
  // ...props
}) => {
  const {
    selectedScenario,
    setSelectedScenario,
    WFRetrieveData,
    // setWFRetrievedData,
    handleWFRetrieveData,
    reloadScenario,
    scenarioList,
    eventDataEditInfo,
    // setEventDataEditInfo,
    clearEventDataEditInfo,
    setSelectedDateRagePicker,
  } = useContext(MarginAnalysisContext)

  const { setSpinning, spinning } = useContext(SpinContext)
  const { setError } = useContext(ErrorContext)

  const height = 400
  const width = 500

  const [scnearioName, setScenarioName] = useState(
    selectedScenario.scenarioName
  )
  const [isPublic, setIsPublic] = useState(false)
  const [comment, setComment] = useState(selectedScenario.comments || '')

  const saveScenarioData = _ => {
    // if scn is old then NEW_SCR_ID set to null
    // if scn is new then SCE_ID set to null
    const { request, events } = WFRetrieveData
    const { scenario } = request
    const { isNew = false } = scenario

    const isOld = scenarioList.find(sc => sc.scenarioName === scnearioName)
    const newScnerio = {
      ...scenario,
      publicPrivate: isPublic ? 'PUB' : 'PRI',
      author: userInfo.userName,
      comments: comment,
    }

    // newScnerio.comments = comment
    // newScnerio.scenarioName = scnearioName

    if (isNew && isOld) {
      message.error('Same Scenario Name already exists.')
      return
    } else if (isNew && !isOld) {
      newScnerio.newScenarioName = scnearioName
      newScnerio.scenarioName = scnearioName
      // newScnerio.author = userInfo.userName
    } else if (!isNew && isOld) {
      // newScnerio.newScenarioName = scnearioName
      newScnerio.scenarioName = scnearioName
    } else if (!isNew && !isOld) {
      newScnerio.newScenarioName = scnearioName
      newScnerio.scenarioName = scnearioName
    }

    const saveEventData = freeEditEngine.applyEdits({
      data: events,
      editInfo: eventDataEditInfo,
    })

    const newRequest = {
      ...request,
      scenario: newScnerio,
      mode: 'WHATIF',
      lostType,
    }

    const newDataPost = {
      ...WFRetrieveData,
      events: saveEventData,
      request: newRequest,
    }

    setSpinning(true)

    saveMarginAnalysisScnerio(targetInfo)(newDataPost).fork(
      setError,
      dataRes => {
        setSpinning(false)
        message.info('Scenario Saved.')

        reloadScenario(targetInfo)

        const scenario = ((dataRes || {}).request || {}).scenario || {}
        setSelectedScenario(scenario)
        setSelectedDateRagePicker([
          moment(scenario.startdate),
          moment(scenario.enddate),
        ])
        clearEventDataEditInfo()
        handleWFRetrieveData(dataRes, onClose)
      }
    )
  }

  return (
    <Modal
      maskClosable={false}
      destroyOnClose
      title="Save Scenario"
      onCancel={onCancelScenarioDialog}
      width={width}
      height={height}
      visible={visible}
      okText="Save Scenario"
      onOk={saveScenarioData}
      okButtonProps={{ loading: spinning }}
      cancelButtonProps={{ loading: spinning }}
    >
      <Spin spinning={spinning}>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '130px 3fr 2fr',
            gridGap: '5px',
            gridTemplateRows: 'min-content auto',
          }}
        >
          <div>Scenario Name :</div>
          <Input
            value={scnearioName}
            onChange={e => setScenarioName(e.target.value)}
          />
          <div
            style={{
              display: 'grid',
              justifyContent: 'center',
              alignContent: 'center',
            }}
          >
            <Checkbox checked={isPublic} onChange={val => setIsPublic(val)}>
              Is Public
            </Checkbox>
          </div>
          <Input.TextArea
            placeholder="Comment"
            value={comment}
            onChange={e => setComment(e.target.value)}
            style={{ display: 'grid', gridColumn: 'span 3' }}
          />
        </div>
      </Spin>
    </Modal>
  )
}

export default SaveScenarioDialog
